'use client';

import { useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { datadogRum } from '@datadog/browser-rum';
import useConfig from '@/hooks/useConfig';
import { DatadogRumEnum } from '@/enums/datadog.enum';

interface ErrorProps {
  error: Error & {
    digest?: string;
  };
}

const WidgetStepsError = ({ error }: ErrorProps) => {
  const t = useTranslations('Widget.pages.steps.errors');
  const { currentStep } = useConfig();

  useEffect(() => {
    datadogRum?.setGlobalContextProperty(DatadogRumEnum.HAS_ERROR, true);
    datadogRum?.setGlobalContextProperty(
      DatadogRumEnum.PATH_ERROR,
      currentStep?.id,
    );
    // Optionally log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <main className='flex h-full flex-col items-center justify-center p-4'>
      <h1 className='text-center vp-title-s'>{t('title')}</h1>
      <h2 className='text-center vp-body-m'>{t('description')}</h2>
    </main>
  );
};

export default WidgetStepsError;
